import { render, staticRenderFns } from "./PrivacyNestRu.vue?vue&type=template&id=191b5340&"
import script from "./PrivacyNestRu.vue?vue&type=script&lang=js&"
export * from "./PrivacyNestRu.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyNestRu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports